let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8tqgK"), load("57vSc"), load("7tpaU"), load("2F69B"), load("h2HOI")]).then(() => parcelRequire('2hWDW'));